import React from 'react';
import './styles/App.css';
import Navbar from './components/Navbar';
import { BrowserRouter as Router, Routes, Route}
	from 'react-router-dom';
import Home from './pages';
import About from './pages/about';
import Upcoming from './pages/upcoming';
import Order from './pages/order';

function App() {
return (
	<Router>
	<Navbar />
	<Routes>
		<Route exact path='/'  element={<Home />} />
		<Route path='/about' exact element={<About/>} />
		<Route path='/upcoming' exact element={<Upcoming/>} />
		<Route path='/order' exact element={<Order/>} />
	</Routes>
	</Router>
);
}

export default App;
